import { render, staticRenderFns } from "./TagsStatusTemplateComponent.vue?vue&type=template&id=6e5e44ac&lang=pug"
import script from "./TagsStatusTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./TagsStatusTemplateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e5e44ac')) {
      api.createRecord('6e5e44ac', component.options)
    } else {
      api.reload('6e5e44ac', component.options)
    }
    module.hot.accept("./TagsStatusTemplateComponent.vue?vue&type=template&id=6e5e44ac&lang=pug", function () {
      api.rerender('6e5e44ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/TagsStatusTemplateComponent.vue"
export default component.exports